/* eslint-disable import/prefer-default-export */
import {
  merchsFetch,
  selectVariantAction,
  openImagesModalAction,
  closeModalAction
} from './'

export const merchsDispatchers = dispatch => ({
  loadMerchs() {
    dispatch(merchsFetch())
  },
  onSelectVariant(merchId, variantURL) {
    dispatch(selectVariantAction({ merchId, variantURL }))
  },
  openImagesModal(imagesModalList) {
    dispatch(openImagesModalAction({ imagesModalList }))
  },
  closeModal() {
    dispatch(closeModalAction())
  }
})
